import { render } from "./AlbumsScreen.vue?vue&type=template&id=dd814542"
import script from "./AlbumsScreen.js?vue&type=script&lang=js"
export * from "./AlbumsScreen.js?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__